import type React from "react";
import {memo, useMemo} from "react";

import {type OptionType} from "../Select";
import SelectGeneric from "../SelectGeneric";

type Value = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";

type Props = {
    value?: Value;
    isDisabled?: boolean;
    onChange: (value: Value) => void;
};

const SelectDayOfTheWeek: React.FC<Props> = ({value, onChange, isDisabled}) => {
    const options = useMemo(
        () =>
            [
                {
                    value: "monday",
                    label: "On Monday"
                },
                {
                    value: "tuesday",
                    label: "On Tuesday"
                },
                {
                    value: "wednesday",
                    label: "On Wednesday"
                },
                {
                    value: "thursday",
                    label: "On Thursday"
                },
                {
                    value: "friday",
                    label: "On Friday"
                },
                {
                    value: "saturday",
                    label: "On Saturday"
                },
                {
                    value: "sunday",
                    label: "On Sunday"
                }
            ] satisfies OptionType<Value>[],
        []
    );

    return (
        <SelectGeneric
            isDisabled={isDisabled}
            options={options}
            placeholder="Day of the week..."
            testID="select-day-of-the-week"
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(SelectDayOfTheWeek);
